import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getFetchCartOptions from "../../../carts/v2/fetch/get-options";
import getCartQueryKey from "../../../carts/v2/get-query-key";
import getFulfillmentOfferings from "../api-calls/fetch";
import getFulfillmentOfferingsQueryKey from "../get-query-key";
var getFetchDigitalOfferingsOptions = function getFetchDigitalOfferingsOptions(_ref) {
  var skuId = _ref.skuId,
    queryClient = _ref.queryClient;
  var offeringTypes = 'DIGITAL';

  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  return {
    queryKey: getFulfillmentOfferingsQueryKey({
      skuId: skuId,
      offeringTypes: offeringTypes
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cart, _cart, currency;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cart = queryClient.getQueryData(getCartQueryKey());
              if (cart) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return queryClient.fetchQuery(getFetchCartOptions({
                queryClient: queryClient
              }));
            case 1:
              cart = _context.sent;
            case 2:
              _cart = cart, currency = _cart.currency;
              return _context.abrupt("return", getFulfillmentOfferings({
                skuId: skuId,
                offeringTypes: offeringTypes,
                currency: currency
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: Infinity,
    retry: false,
    retryOnMount: false,
    gcTime: Infinity
  };
};
export default getFetchDigitalOfferingsOptions;